import React, { memo } from 'react';
import PropTypes from 'prop-types';

import CdnImage, { cdnImageTypes } from '@prisjakt/ui-cdn-image';
import * as S from './styles';

export const { VARIANTS } = S;

const StoreLogo = ({ name, storeId, featured, hasImage, variant }) => {
  const shouldRenderLogo =
    hasImage &&
    (featured ||
      variant === S.VARIANTS.CAMPAIGN ||
      variant === S.VARIANTS.SOTY);

  return (
    <S.StoreLogo showLogo={shouldRenderLogo} variant={variant}>
      {shouldRenderLogo ? (
        <CdnImage
          type={cdnImageTypes.store}
          name={storeId}
          width={S.variantToWidth[variant]}
          alt={name}
        />
      ) : (
        <S.StoreLogoText>{name}</S.StoreLogoText>
      )}
    </S.StoreLogo>
  );
};

const { string, bool, number, oneOf } = PropTypes;

StoreLogo.propTypes = {
  name: string.isRequired,
  storeId: number.isRequired,
  featured: bool,
  hasImage: bool.isRequired,
  variant: oneOf(Object.values(S.VARIANTS)),
};

StoreLogo.defaultProps = {
  featured: false,
  variant: S.VARIANTS.DEFAULT,
};

export default memo(StoreLogo);
